/** In this file contains the landing page UI designs and functionality **/
import constantVariables from './../../dataset/constantVariables.json';
import { Carousel } from 'react-bootstrap';

//Landing or Home page
export default function HeroBanner(){
	
	
	/** This function is used to scroll down to the section 
	 * @sectionId - pass the id or section name
	**/
	const scrollToSection = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) {
		  section.scrollIntoView({ behavior: 'smooth' });
		}
    };
  
	return (<>
	<div id="indexPage">
	{/** Hero Banner Section **/}
	<section id="hero" className="d-flex align-items-center justify-content-center">
		<div className="container">
			<div className="row justify-content-center mb-4">
				<div className="col-xl-6 col-lg-8">
					<h2>{constantVariables.landing.welcome}</h2>
					<h1>{constantVariables.landing.head1} <br />{constantVariables.landing.head2}</h1>
					<span onClick={() => scrollToSection('about')} className="btn btn-tmBlue px-4">{constantVariables.landing.getStarted}</span>
				</div>
			</div>
			<div className="row justify-content-center ">
				<div className="col-lg-3 col-6">
					<div className="imgSec">
						<img src="/assets/img/babyImg-01.jpg" className="img-fluid" alt="lo" />
					</div>
					<h3 className="w-100">{constantVariables.sidebar.measurement}</h3>
				</div>
				<div className="col-lg-3 col-6">
					<div className="imgSec">
						<img src="/assets/img/babyImg-02.jpg" className="img-fluid" alt="lo" />
					</div>
					<h3>{constantVariables.sidebar.vitals}</h3>
				</div>
				<div className="col-lg-3 col-6">
					<div className="imgSec">
						<img src="/assets/img/babyImg-03.jpg" className="img-fluid" alt="lo" />
					</div>
					<h3>{constantVariables.sidebar.development}</h3>
				</div>
				<div className="col-lg-3 col-6">
					<div className="imgSec">
						<img src="/assets/img/babyImg-04.jpg" className="img-fluid" alt="lo" />
					</div>
					<h3>{constantVariables.sidebar.vaccination}</h3>
				</div>
			</div>
		</div>
	</section>
	
	{/** About Section **/}
	<section id="about" className="aboutus section">
		<div className="container">
			<div className="row">  
				<div className="col-lg-5">  	
					<Carousel>
					  <Carousel.Item>
						<img src="/assets/img/web-about-img01.png" className="d-block w-100" alt="lo" />
					  </Carousel.Item>
					  <Carousel.Item>
						<img src="/assets/img/web-about-img02.png" className="d-block w-100" alt="lo" />
					  </Carousel.Item>
					</Carousel>
				 </div> 
				<div className="col-lg-7 ps-lg-5">  
					<div className="sectionTitle">
						<h5>{constantVariables.landing.weAre}</h5>
						<h4>{constantVariables.landing.weAre1} <br />{constantVariables.landing.weAre2}</h4>
					</div>
					<div className="sectionContent">
						<p>{constantVariables.landing.weAre3}</p>
						
						<p>{constantVariables.landing.weAre4}</p>
						
						<span onClick={() => scrollToSection('services')} className="btn btn-tmBlue px-4 h4 mt-3">{constantVariables.landing.getStarted}</span>
					</div>
				</div>
			</div>
		</div>
	</section>
	
	{/** Services Section **/}
	<section id="services" className="servicesSec section">
		<div className="container">
			{/** Services 01 **/}
			<div className="row mb-5"> 
				<div className="col-lg-6">  
					<div className="sectionTitle">
						<h5>{constantVariables.landing.weDo}</h5>
						<h4>{constantVariables.landing.weDo1} <br /> {constantVariables.landing.weDo2}</h4>
					</div>
					<div className="sectionContent">
						<p>{constantVariables.landing.weDo3}</p>
						<p className="botBdr"></p>
					</div>
				</div>				 
				<div className="col-lg-6 clearfix">  
					<div className="imgBox clearfix float-end"> 
						<img src="/assets/img/services-Mobimg-01.png" className="mobImg" alt="lo" /> 
						<img src="/assets/img/services-img-01.png" className="serImg" alt="lo" />
					</div> 
				</div> 
			</div>
			
			{/** Services 02 **/}
			<div className="row mb-5"> 			 
				<div className="col-lg-6">  
					<div className="imgBox pink clearfix"> 
						<img src="/assets/img/services-Mobimg-02.png" className="mobImg" alt="lo" /> 
						<img src="/assets/img/services-img-02.png" className="serImg" alt="lo" />
					</div> 
				</div> 
				<div className="col-lg-6">  
					<div className="sectionTitle">
						<h5 className="blueDot">{constantVariables.landing.weDo}</h5>
						<h4>{constantVariables.landing.weDo4}<br />{constantVariables.landing.weDo5}</h4>
					</div>
					<div className="sectionContent">
						<p>{constantVariables.landing.weDo6}</p>
						<p className="botBdr blue"></p>
					</div>
				</div>	
			</div>
			
			{/** Services 03 **/}
			<div className="row mb-5"> 
				<div className="col-lg-6">  
					<div className="sectionTitle">
						<h5>{constantVariables.landing.weDo}</h5>
						<h4>{constantVariables.landing.weDo7} <br /> {constantVariables.landing.weDo8}</h4>
					</div>
					<div className="sectionContent">
						<p>{constantVariables.landing.weDo9}</p>
						<p className="botBdr"></p>
					</div>
				</div>				 
				<div className="col-lg-6 clearfix">  
					<div className="imgBox clearfix float-end"> 
						<img src="/assets/img/services-Mobimg-03.png" className="mobImg" alt="lo" /> 
						<img src="/assets/img/services-img-03.png" className="serImg" alt="lo" />
					</div> 
				</div> 
			</div>
			
			{/** Services 04 **/}
			<div className="row"> 			 
				<div className="col-lg-6">  
					<div className="imgBox pink clearfix"> 
						<img src="/assets/img/services-Mobimg-04.png" className="mobImg" alt="lo" /> 
						<img src="/assets/img/services-img-04.png" className="serImg" alt="lo" />
					</div> 
				</div> 
				<div className="col-lg-6">  
					<div className="sectionTitle">
						<h5 className="blueDot">{constantVariables.landing.weDo}</h5>
						<h4>{constantVariables.landing.weDo10} <br />{constantVariables.landing.weDo11}</h4>
					</div>
					<div className="sectionContent">
						<p>{constantVariables.landing.weDo12}</p>
						<p className="botBdr blue"></p>
					</div>
				</div>	
			</div>
		</div>
	</section>
	</div>
	</>);
}